import { render } from "./WithdrawalRecords.vue?vue&type=template&id=4a985b97&scoped=true"
import script from "./WithdrawalRecords.vue?vue&type=script&lang=js"
export * from "./WithdrawalRecords.vue?vue&type=script&lang=js"

import "./WithdrawalRecords.vue?vue&type=style&index=0&id=4a985b97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a985b97"]])

export default __exports__